import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * A browser resets scroll on a page load; a client-side router does not, so
 * without this a visitor arrives at a new page already scrolled halfway
 * down it. A hash target keeps its own behaviour.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
